import { apiClient } from "@/lib/api/client";

export type ActivityPolicyMode = "sampling_metadata" | "fixed_window";

export type WorkspaceActivityPolicyDto = {
  id: string;
  tenant_id: string;
  mode: ActivityPolicyMode;
  default_window_seconds: number;
  sampling_multiplier: number;
  min_window_seconds: number;
  max_window_seconds: number;
  created_at: string;
  updated_at: string;
};

export type WorkspaceActivityPolicyUpdateBody = Partial<
  Pick<
    WorkspaceActivityPolicyDto,
    "mode" | "default_window_seconds" | "sampling_multiplier" | "min_window_seconds" | "max_window_seconds"
  >
>;

export async function getWorkspaceActivityPolicy(
  tenantId?: string | null,
): Promise<WorkspaceActivityPolicyDto> {
  const { data } = await apiClient.get<WorkspaceActivityPolicyDto>("/activity-policy/workspace", {
    params: tenantId ? { tenant_id: tenantId } : undefined,
  });
  return data;
}

export async function updateWorkspaceActivityPolicy(
  body: WorkspaceActivityPolicyUpdateBody,
  tenantId?: string | null,
): Promise<WorkspaceActivityPolicyDto> {
  const { data } = await apiClient.put<WorkspaceActivityPolicyDto>("/activity-policy/workspace", body, {
    params: tenantId ? { tenant_id: tenantId } : undefined,
  });
  return data;
}
